import { ContextMenuItemType } from '../models/ContextMenuItemType';
import React from 'react';
import { IContextMenuProps } from '../interfaces/ContextMenu';
import ContextCheckboxItem from './contextItem/ContextCheckboxItem';
import { ContextMenuItem } from './contextItem/ContextMenuItem';
import './styles.scss';

export function ContextMenuComponent(props: IContextMenuProps): JSX.Element {
    const { items, visible } = props;

    return (
        <ul className="context-menu" onContextMenu={e => e.preventDefault()}>
            {items.map((item, index) =>
                item.itemType === ContextMenuItemType.Checkbox ? (
                    <ContextCheckboxItem
                        label={item.label}
                        value={item.initialValue || false}
                        hasSeparator={item.hasSeparator}
                        disabled={item.disabled}
                        visible={visible}
                        onCheckboxChange={item.onChange}
                        onCloseMenu={props.onCloseMenu}
                    />
                ) : (
                    <ContextMenuItem
                        key={index.toString()}
                        label={item.label}
                        shortcutLabel={item.shortcutLabel}
                        onCloseMenu={props.onCloseMenu}
                        onItemClick={item.onItemClick}
                        hasSeparator={item.hasSeparator}
                        subMenu={item.subMenu}
                        iconName={item.iconName}
                        disabled={item.disabled}
                        subMenuLeftArrow={item.subMenuLeftArrow}
                    />
                ),
            )}
        </ul>
    );
}
